import { FaClock, FaMapMarkerAlt, FaDollarSign, FaTags, FaBriefcase, FaCalendarAlt, FaPhone, FaUsers, FaEnvelope, FaHourglass, FaTools, FaUserCog, FaHammer, FaWrench, FaBoxOpen, FaScrewdriver } from 'react-icons/fa';
import { FaHouse } from 'react-icons/fa6';

// Function to render the appropriate icon based on the name
export const renderIcon = (iconName) => {

  // Convert the name to lowercase
  const lowercaseName = iconName.toLowerCase();

  // Check the lowercase name and return the corresponding icon component
  switch (lowercaseName) {

    /*----- Service Icons -----*/
    case 'custom craft':
      return <FaHammer />; // Wifi

    case 'carpentry work':
      return <FaWrench />; // Tv

    case 'furniture repair':
      return <FaTools />; // Box

    case 'cabinet design':
      return <FaBoxOpen />; // Tools

    case 'flooring installation':
      return <FaScrewdriver />; // Headset

    case 'deck construction':
      return <FaHouse />; // Home


    /*----- Page Sidebar -----*/
    case 'date':
    case 'days':
    case 'deadline':
      return <FaCalendarAlt />; // Calendar icon

    case 'timing':
    case 'hours':
      return <FaClock />; // Clock icon

    case 'duration':
      return <FaHourglass />; // Hourglass icon

    case 'client':
    case 'position':
      return <FaUsers />; // Users icon

    case 'category':
      return <FaTags />; // Tags icon

    case 'location':
      return <FaMapMarkerAlt />; // Location icon

    case 'salary':
    case 'cost':
      return <FaDollarSign />; // Dollar icon

    case 'experience':
      return <FaBriefcase />; // Briefcase icon

    case 'leaddesigner':
      return <FaUserCog />; // Leader icon

    case 'number':
      return <FaPhone />; // Phone icon

    case 'email':
      return <FaEnvelope />; // Envelope icon

    default: 
      return null; // Return null if no matching icon is found
  }

};